module.exports = __webpack_public_path__ + "img/2.e56f4cbc.png";